// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controller-area[data-v-33aa9be9]{position:absolute;bottom:9%;right:5px}.sound-view[data-v-33aa9be9]{position:relative;width:100%;height:100%;top:0;left:0;background-color:#000}.outer[data-v-33aa9be9]{width:inherit;height:inherit}.progress-circular--center[data-v-33aa9be9]{position:absolute;margin-top:18%;margin-left:50%;transform:translateX(-50%)}.reticle[data-v-33aa9be9]{position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
